import { useState } from 'react';
import styles from '../../styles/module/NotFound.module.css';

const NotFound = ({
    statusCode = 404,
    pageTitle = 'Page Not Found',
    description = "The page you're looking for doesn't exist or has been moved.",
    shouldShowBgGradient = true
}) => {
    const [isHovered, setIsHovered] = useState(false);

    const handleGoHome = () => {
        window.location.href = '/';
    };

    const handleGoBack = () => {
        window.history.back();
    };

    return (
        <div
            className={styles.container}
            style={{ background: shouldShowBgGradient ? 'var(--gradient-blue)' : 'var(--primary-color)' }}
        >
            <div className={styles.content}>
                <div className={styles.errorCode}>
                    <span className={styles.four}>{Math.floor(statusCode / 100)}</span>
                    <span className={styles.zero}>{Math.floor((statusCode % 100) / 10)}</span>
                    <span className={styles.four}>{statusCode % 10}</span>
                </div>

                <h1 className={styles.title}>{pageTitle}</h1>
                <p className={styles.description}>{description}</p>

                <div className={styles.actions}>
                    <button
                        className={styles.primaryButton}
                        onClick={handleGoHome}
                        onMouseEnter={() => setIsHovered(true)}
                        onMouseLeave={() => setIsHovered(false)}
                    >
                        Go Home
                    </button>
                    <button className={styles.secondaryButton} onClick={handleGoBack}>
                        Go Back
                    </button>
                </div>
            </div>
        </div>
    );
};

export default NotFound;
